/**
 * Build a responsive srcset for locally hosted WebP images that ship with a
 * `-700` variant alongside the full-width (1400px) file.
 * Returns undefined for remote or non-WebP sources.
 */
export const buildWebpSrcSet = (src?: string): string | undefined => {
  if (!src || !src.startsWith("/images/") || !src.endsWith(".webp")) {
    return undefined;
  }
  const base = src.slice(0, -".webp".length);
  return `${base}-700.webp 700w, ${src} 1400w`;
};
